var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksInProgressCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 2.00002H10.38C10.1 1.22669 9.36667 0.666687 8.5 0.666687C7.63333 0.666687 6.9 1.22669 6.62 2.00002H3.83333C3.1 2.00002 2.5 2.60002 2.5 3.33335V14C2.5 14.7334 3.1 15.3334 3.83333 15.3334H13.1667C13.9 15.3334 14.5 14.7334 14.5 14V3.33335C14.5 2.60002 13.9 2.00002 13.1667 2.00002ZM8.5 2.00002C8.86667 2.00002 9.16667 2.30002 9.16667 2.66669C9.16667 3.03335 8.86667 3.33335 8.5 3.33335C8.13333 3.33335 7.83333 3.03335 7.83333 2.66669C7.83333 2.30002 8.13333 2.00002 8.5 2.00002ZM12.5 14H4.5C4.13333 14 3.83333 13.7 3.83333 13.3334V4.00002C3.83333 3.63335 4.13333 3.33335 4.5 3.33335H5.16667V4.00002C5.16667 4.73335 5.76667 5.33335 6.5 5.33335H10.5C11.2333 5.33335 11.8333 4.73335 11.8333 4.00002V3.33335H12.5C12.8667 3.33335 13.1667 3.63335 13.1667 4.00002V13.3334C13.1667 13.7 12.8667 14 12.5 14Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 3,
    r: 2.9,
    fill: "#FF9831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksInProgressCircle);
export default __webpack_public_path__ + "static/media/tasks-in-progress-circle.d1633074b819a7eeae8b91c67f05ae16.svg";
export { ForwardRef as ReactComponent };